import {
    FunctionField,
    TextField,
    useLocaleState,
    usePermissions,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaListView } from "shared/src/components/views/RaListView";
import { RaShowButton } from "shared/src/components/buttons/RaShowButton";

export const MaintenanceList = (props) => {
    const translate = useTranslate();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();
    const [locale] = useLocaleState();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource: "skus", attribute })) {
        return <AccessRightsError />;
    }

    return (
        <RaListView
            {...props}
            resource="skus"
            actions={<ToolbarWithHistory export={true} />}
            pagination={<DefaultPagination />}
            perPage={50}
            sort={{ field: "maintenanceOverdueDays", order: "DESC" }}
            filter={{ maintenanceDue: true }}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <TextField label="equip.labelNumber" source="labelNumber" />
                <TextField
                    label="equip.name"
                    source={`product.name.${locale}`}
                    sortable={false}
                />
                <TextField
                    label="equip.maintenanceName"
                    source="maintenanceName"
                    sortable={false}
                />
                <FunctionField
                    label="equip.maintenanceRentalDays"
                    render={(record) =>
                        `${record.maintenanceRentalDaysCount} / ${record.maintenanceRentalDays}`
                    }
                    sortable={false}
                />
                <FunctionField
                    label="equip.maintenanceOverdueDays"
                    source="maintenanceOverdueDays"
                    render={(record) =>
                        `${record.maintenanceOverdueDays} ${translate(
                            "equip." +
                                (record.maintenanceOverdueDays === 1
                                    ? "day"
                                    : "days")
                        )}`
                    }
                />
                <TextField
                    label="equip.maintenanceCreatedBy"
                    source="maintenanceCreatedBy.fullName"
                    sortable={false}
                />
                <RaShowButton resource="skus" />
            </DatagridWithHistory>
        </RaListView>
    );
};
